import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { UserDataService } from '@core/services/user-data/user-data.service';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';
import { IProductCommandContext } from '@shared/models/command';
import { BaseProductCommand } from '@shared/commands/base-product.command';
import { CardRequisitesComponent } from '@pages/product/_modals/card-requisites/card-requisites.component';
import { ProductTypes } from '@shared/models/products.model';

@Injectable({ providedIn: 'root' })
export class RequisitesCardCommand extends BaseProductCommand {
  readonly type = 'requisites-card';
  readonly title = 'Реквизиты карты';
  readonly icon = 'requisites-card';
  readonly productType = ProductTypes.CARD;
  readonly isInfoAction = false;
  readonly settingsNames = undefined;
  readonly order = 4; // Четвертый в actions для card (после paymentOrTransfer)

  constructor(
    commandAvailabilityService: CommandAvailabilityService,
    private modalCtrl: ModalController,
    private userDataService: UserDataService
  ) {
    super(commandAvailabilityService);
  }

  async execute(context: IProductCommandContext): Promise<void> {
    const clientInfo = await this.userDataService.getClientInfo().toPromise();
    const modal = await this.modalCtrl.create({
      component: CardRequisitesComponent,
      handle: false,
      cssClass: 'custom',
      initialBreakpoint: 1,
      componentProps: {
        product: context.data,
        staticHeight: true,
        userPhone: clientInfo.unmaskedPhone
      }
    });

    await modal.present();
  }
}

